$(document).ready(function() {  
  /*********************
    Thumbnails slider
  *********************/
  // Change the main image whenever a thumbnail button is activated
  $('.thumbnails-slider').on('init', function(e, slider) {
    $(slider.$slides.find('.thumbnail-button')).each(function(index) {
      $(this).on('click', function() {
        // Move aria-current="true" to this button
        $(slider.$slides.find('.thumbnail-button').removeAttr('aria-current'));
        $(this).attr('aria-current', true);

        // Change the main image to match this thumbnail button
        var index = $(this).closest('.slick-slide').data('slick-index');
        $('.main-image-slider').slick('slickGoTo', index);
      });
    });
  });
  
  // Initialize the slider
  $('.thumbnails-slider').slick({
    vertical: true,
    slidesToShow: 4,
    infinite: false,
    instructionsText: '',

    regionLabel: 'thumbnails carousel',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          vertical: false,
          slidesToShow: 3,
          slidesToScroll: 3,
          infinite: true,
          dots: true,


        }
      },
    ]
  });
  
  
  /********************
    Main image slider
  *********************/
  $('.main-image-slider').slick({
    slidesToShow: 1,
    draggable: false,
    instructionsText: '',
  slidesToScroll: 1,
  autoplay: true,
  autoplaySpeed: 2000,
    regionLabel: 'main image carousel',
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          arrow: false,
        }
      },
    ]
  });
  
    // Update the thumbnail slider when the user changes the main slider directly.
    $('.main-image-slider').on('beforeChange', function(e, slider, currentSlide, nextSlide) {
      // Remove aria-current from the last selected thumbnail image button
      $('.thumbnails-slider .thumbnail-button[aria-current="true"]').removeAttr('aria-current');
      
      // Select the thumbnail image button that goes with this main image. Most importantly, this updates Slick's internal state to be consistent with the visual change.
      $('.thumbnails-slider').slick('slickGoTo', nextSlide);

      // Add aria-current="true" to the correct thumbnail image button to convey to screen readers that it's active.
      $('.thumbnails-slider .thumbnail-button:eq(' + nextSlide + ')').attr('aria-current', true);
    }); 
});



$(document).ready(function(){
  

$('.slick_product_slider').slick({
  // dots: true,
  infinite: true,
  speed: 300,
  slidesToShow: 4,
  slidesToScroll: 4,
  prevArrow: '<button class="flickity-button flickity-prev-next-button previous" type="button" aria-label="Previous"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow"></path></svg></button>',
  nextArrow: '<button class="flickity-button flickity-prev-next-button next" type="button" aria-label="Next"><svg class="flickity-button-icon" viewBox="0 0 100 100"><path d="M 10,50 L 60,100 L 70,90 L 30,50  L 70,10 L 60,0 Z" class="arrow" transform="translate(100, 100) rotate(180) "></path></svg></button>',
  responsive: [
    {
      breakpoint: 1024,
      settings: {
        slidesToShow: 3,
        slidesToScroll: 3,
        infinite: true,
        dots: true
      }
    },
    {
      breakpoint: 600,
      settings: {
        slidesToShow: 2,
        slidesToScroll: 2
      }
    },
  ]
});

});